// extracted by mini-css-extract-plugin
export default {"wrapper":"NeqasgzOqSBmbs2yseYC","login":"Y2XuLCpybI6v9gNxuzAA"};